import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';
import type { TLoansFirstTouchClient, TLoansFirstTouchResponse } from 'shared/types/TLoansService';

export const sendLoansFirstTouchApi = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    sendLoansFirstTouch: build.mutation<TLoansFirstTouchResponse, TLoansFirstTouchClient>({
      query: (query) => ({
        url: BFF_API_ROUTES.sendFirstTouch,
        method: 'POST',
        body: query,
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});
